import React from "react";
import { Link } from "react-router-dom";
import { FaceBook, Instagram, Linkedin, Twitter } from "../images/icons";
import { DumeleLogo, HivosLogo } from "../images/logos";
import whmLogo from "../images/whm.png";

const Footer = () => {
  return (
    <div className="bg-eerie py-16 px-16 md:px-6 text-white flex flex-col items-center space-y-10">
      <div className="flex space-x-10">
        <DumeleLogo />
        <img src={whmLogo} alt="" className="h-[45px]" />
        <HivosLogo />
      </div>
      <div className="footer-links">
        <ul className="flex md:flex-col space-x-16 md:space-y-4 md:space-x-0 md:text-center font-semibold md:font-normal">
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/">Collection</Link>
          </li>
          <li>
            <Link to="/">Exhibition</Link>
          </li>
          <li>
            <Link to="/">Donate</Link>
          </li>
        </ul>
      </div>
      <div>
        <ul className="flex space-x-8 md:scale-125">
          <li>
            <Link to={{ pathname: "https://facebook.com/" }} target="_blank">
              <FaceBook />
            </Link>
          </li>
          <li>
            <Link to={{ pathname: "https://instagram.com/" }} target="_blank">
              <Instagram />
            </Link>
          </li>
          <li>
            <Link to={{ pathname: "https://twitter.com/" }} target="_blank">
              <Twitter />
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "https://linkedin.com.com/" }}
              target="_blank"
            >
              <Linkedin />
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h2 className="text-lg md:text-sm">Phone +260 (0) 889 647 8839</h2>
      </div>
      <div>
        <h4 className="text-base font-light text-center md:text-sm">
          Copyright &copy; 2022 Dumele. All rights reserved
        </h4>
      </div>
    </div>
  );
};

export default Footer;
